import {toast} from "react-toastify";

export const useToaster = () => {
    const success = (message: string, id?:string) => {
        toast.success(message, {
            toastId: id
        });
    }

    const error = (message: string,id?:string) => {
        toast.error(message, {
            toastId: id
        });
    }

    const info = (message: string,id?:string) => {
        toast.info(message, {
            toastId: id
        });
    }

    const warn = (message: string,id?:string) => {
        toast.warn(message,{
            toastId: id
        });
    }

    return {
        success,
        error,
        info,
        warn
    }
}
